import styled from 'styled-components';
import { ICON_DEFAULTS } from './Icon';

const IconQuestionMark = ({ className, width, height, stroke, fill }) => {
  return (
    <SVG
      className={className}
      width={width || ICON_DEFAULTS.WIDTH}
      height={height || ICON_DEFAULTS.HEIGHT}
      viewBox="0 0 14 14"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7 13.5C8.72391 13.5 10.3772 12.8152 11.5962 11.5962C12.8152 10.3772 13.5 8.72391 13.5 7C13.5 5.27609 12.8152 3.62279 11.5962 2.40381C10.3772 1.18482 8.72391 0.5 7 0.5C5.27609 0.5 3.62279 1.18482 2.40381 2.40381C1.18482 3.62279 0.5 5.27609 0.5 7C0.5 8.72391 1.18482 10.3772 2.40381 11.5962C3.62279 12.8152 5.27609 13.5 7 13.5Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.25 5.25C5.24968 4.99097 5.3069 4.73509 5.41753 4.50087C5.52816 4.26665 5.68944 4.05992 5.88971 3.89563C6.08998 3.73134 6.32424 3.61358 6.57557 3.55087C6.8269 3.48816 7.08902 3.48206 7.343 3.533C7.59687 3.58358 7.83637 3.68979 8.04429 3.84399C8.25221 3.99818 8.42338 4.19653 8.54549 4.42478C8.6676 4.65303 8.73761 4.9055 8.75049 5.16403C8.76338 5.42257 8.71881 5.68075 8.62 5.92C8.48742 6.23991 8.26291 6.51329 7.97489 6.70554C7.68687 6.89779 7.34829 7.00027 7.002 7V8.167M7 10.459C6.9337 10.459 6.87011 10.4327 6.82322 10.3858C6.77634 10.3389 6.75 10.2753 6.75 10.209C6.75 10.1427 6.77634 10.0791 6.82322 10.0322C6.87011 9.98534 6.9337 9.959 7 9.959C7.06631 9.959 7.12989 9.98534 7.17678 10.0322C7.22366 10.0791 7.25 10.1427 7.25 10.209C7.25 10.2753 7.22366 10.3389 7.17678 10.3858C7.12989 10.4327 7.06631 10.459 7 10.459Z"
        stroke={stroke}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </SVG>
  );
};

const SVG = styled('svg')({
  fill: 'none',
  stroke: 'currentcolor',
});

export { IconQuestionMark };
